import React from "react";
import { OutlinedButtonStyled } from "../../OutlinedButtonStyled";
import { ToolbarRow } from "./bulkReviewResolveStyles";

type BulkReviewResolveCollapseToolbarProps = {
    expandedCount: number;
    onCollapseAll: () => void;
};

const BulkReviewResolveCollapseToolbar: React.FC<BulkReviewResolveCollapseToolbarProps> = ({
    expandedCount,
    onCollapseAll,
}) => (
    <ToolbarRow>
        <OutlinedButtonStyled
            width={100}
            height={26}
            disabled={expandedCount === 0}
            onClick={onCollapseAll}
        >
            Collapse all
        </OutlinedButtonStyled>
    </ToolbarRow>
);

export default BulkReviewResolveCollapseToolbar;
